import React, { useEffect, useState } from 'react';
import { DataGridPremium } from '@mui/x-data-grid-premium';

import { PageInfoHeader } from 'components/PageInfoHeader/PageInfoHeader';
import AddPatientSourceModal from 'components/pages/setup/PatientSourceManagement/AddPatientSourceModal/AddPatientSourceModal';

import { PatientSourceApi } from '../../../../api';
import ModalBoxes from '../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../common/general/Button';
import Icon from '../../../../common/general/Icon';
import { MANAGE_PATIENT_SOURCE } from '../../../../constants/userOperations';
import { userHasAccessTo } from '../../../../services/auth';

import './PatientSourceManagement.scss';

const columns = [
  {
    field: 'source',
    headerName: 'Patient Source',
    flex: 1
  },
  {
    field: 'type',
    headerName: 'Type',
    flex: 1
  }
];

export default function PatientSourceManagement() {
  const [sources, setSources] = useState([]);
  useEffect(() => {
    PatientSourceApi.getAllPatientSources().then(function({ data }) {
      setSources(data);
    });
  }, []);
  return (
    <div className="eui-patient-source-management">
      <PageInfoHeader
        right={
          userHasAccessTo(MANAGE_PATIENT_SOURCE) && (
            <Button size="h28" onClick={openCreatePatientSourceModal}>
              <Icon>add</Icon>Add Patient Source
            </Button>
          )
        }
      />
      <DataGridPremium
        rows={sources}
        columns={columns}
        disableRowSelectionOnClick
        disableRowGrouping
        disableAggregation
        disablePivoting
        showToolbar
        initialState={{
          sorting: {
            sortModel: [{ field: 'source', sort: 'asc' }]
          }
        }}
        slotProps={{
          toolbar: {
            csvOptions: { disableToolbarButton: true },
            printOptions: { disableToolbarButton: true },
            excelOptions: { disableToolbarButton: true }
          }
        }}
      />
    </div>
  );
  function openCreatePatientSourceModal() {
    ModalBoxes.open({
      component: <AddPatientSourceModal sources={sources} />,
      onClose(data) {
        if (data?.id && data?.source && data?.type) {
          setSources(state => [...state, data]);
        }
      }
    });
  }
}
